import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";
import { loadWaTemplate, setWaCache, fillTemplate } from "@/lib/whatsapp";
import { GoldButton, GhostButton, inputCls } from "@/components/common";

const SAMPLE = { start: "2026-11-05T15:30", client_first_name: "Maria", treatment_name: "Pulizia viso", operator_name: "Micol" };
const TAGS = ["{nome}", "{data}", "{ora}", "{trattamento}", "{operatore}"];

export const WaTemplateDialog = ({ open, onOpenChange }) => {
  const [t, setT] = useState("");
  const [def, setDef] = useState("");
  useEffect(() => {
    if (!open) { return; }
    loadWaTemplate(true).then((d) => { setT(d.template); setDef(d.default_template); });
  }, [open]);

  const save = async () => {
    try {
      const { data } = await api.put("/settings/whatsapp", { template: t });
      setWaCache(data);
      toast.success("Testo del promemoria salvato");
      onOpenChange(false);
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#FDFBF7] border-[#E8E1D7] max-w-lg" data-testid="wa-template-dialog">
        <DialogHeader><DialogTitle className="font-serif text-3xl font-normal">Testo promemoria WhatsApp</DialogTitle></DialogHeader>
        <p className="text-sm text-[#6E675F]">Tocca una parola tra graffe per inserirla: verrà sostituita con i dati dell'appuntamento.</p>
        <div className="flex flex-wrap gap-2">
          {TAGS.map((tag) => (
            <button key={tag} type="button" onClick={() => setT((p) => `${p}${p.endsWith(" ") || !p ? "" : " "}${tag}`)} className="rounded-full border border-[#C5A059]/50 px-3 py-1 text-xs text-[#8A6A22] hover:bg-[#C5A059]/10" data-testid={`wa-tag-${tag.slice(1, -1)}`}>{tag}</button>
          ))}
        </div>
        <textarea rows={5} className={inputCls} value={t} onChange={(e) => setT(e.target.value)} data-testid="wa-template-input" />
        <div className="rounded-2xl bg-[#E7F7EC] p-4 text-sm text-[#1F3B2A] whitespace-pre-wrap" data-testid="wa-template-preview">
          <div className="mb-1 text-[10px] uppercase tracking-[0.18em] text-[#128C4B]">Anteprima</div>
          {fillTemplate(t, SAMPLE)}
        </div>
        <div className="flex justify-between gap-2">
          <GhostButton onClick={() => setT(def)} data-testid="wa-template-reset">Ripristina testo standard</GhostButton>
          <GoldButton onClick={save} disabled={!t.trim()} data-testid="wa-template-save">Salva</GoldButton>
        </div>
      </DialogContent>
    </Dialog>
  );
};
